const getStatusVariant = (status) => {
  switch (status) {
    case 'Diterima':
      return 'approved';
    case 'Ditolak':
      return 'rejected';
    case 'Diproses':
      return 'processing';
    default:
      return 'default';
  }
};

export default getStatusVariant;
